module.exports = __webpack_public_path__ + "d.no1.036950f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/d.no1.jpg
// module id = bnSO
// module chunks = 0